import { render, staticRenderFns } from "./form-sent.vue?vue&type=template&id=20b3f49c&"
import script from "./form-sent.vue?vue&type=script&lang=js&"
export * from "./form-sent.vue?vue&type=script&lang=js&"
import style0 from "./form-sent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports